<template>
    <v-row class="pa-6"
           style="position: absolute; bottom: 0; width: 100%">
        <v-col class="d-flex justify-space-between align-center" cols="6">
            <p class="body-1 mb-0">
                <v-icon :sixe="24">mdi-translate</v-icon>&nbsp;{{ $t('lang') }}
            </p>
        </v-col>
        <v-col class="d-flex justify-space-between align-center" cols="6">
            <div>
                <v-btn @click="changeLocale('de')" icon>DE</v-btn>
            </div>
            <div>
                <v-btn @click="changeLocale('en')" icon>EN</v-btn>
            </div>
        </v-col>
    </v-row>
</template>

<script>
import { localize } from 'vee-validate'
export default {
  name: 'LocalesComponent',
  mounted () {
    this.changeLocale('de')
  },
  methods: {
    changeLocale (lang) {
      this.$vuetify.lang.current = lang
      this.$root.$i18n.locale = lang
      import('vee-validate/dist/locale/' + lang).then((locale) => {
        localize(lang, locale)
        document.documentElement.lang = lang
        this.$store.dispatch('setLang', lang)
        this.$root.$emit('change-locale')
      })
    }
  }
}
</script>

<style scoped>

</style>
